import styled from '@emotion/styled';
import { palette } from '../../../Dashboard.styled';

export const Item = styled.div<{ clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid ${palette.borderSoft};

  &:first-of-type {
    border-top: none;
  }

  ${({ clickable }) =>
    clickable &&
    `
    cursor: pointer;

    &:hover span,
    &:focus-visible span {
      text-decoration: underline;
    }
  `}
`;

export const Dot = styled.span`
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${palette.green};
`;

export const Title = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: ${palette.ink};
`;

export const DateLabel = styled.span`
  flex: 0 0 auto;
  font-size: 12px;
  color: ${palette.muted};
`;
